import { FlexColAlignCenterBoth } from 'components/primitives/flex';
import styled from 'styled-components';

const LogoIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.9971 28C6.28103 28 0 21.719 0 13.9971C0 6.27515 6.28103 0 13.9971 0C21.719 0 27.9941 6.28103 27.9941 13.9971C27.9941 21.7131 21.719 28 13.9971 28ZM13.9971 1.90548C7.32787 1.90548 1.8996 7.33375 1.8996 14.0029C1.8996 20.6721 7.32787 26.1004 13.9971 26.1004C20.6662 26.1004 26.0945 20.6721 26.0945 14.0029C26.0945 7.32787 20.6662 1.90548 13.9971 1.90548Z"
      fill="#001D58"
    />
    <path
      d="M20.4603 19.0486C18.9665 19.0486 17.5726 18.4547 16.5376 17.3725L16.4611 17.2902C15.7965 16.6197 14.9085 16.2492 13.9616 16.2492C13.003 16.2492 12.115 16.6197 11.4504 17.2902L11.3798 17.3725C10.3447 18.4547 8.95091 19.0486 7.45711 19.0486C5.95742 19.0486 4.55772 18.4488 3.52264 17.3666C2.84631 16.6609 1.94062 16.2728 0.964355 16.2728V14.3673C2.46404 14.3673 3.85786 14.9671 4.89294 16.0493C5.56927 16.7609 6.47496 17.149 7.45123 17.149C8.39809 17.149 9.28613 16.7785 9.9507 16.1081L10.0154 16.0316C11.0505 14.9436 12.4502 14.3438 13.9499 14.3438C15.4554 14.3438 16.8551 14.9436 17.8902 16.0316L17.9608 16.114C18.6253 16.7785 19.5075 17.1432 20.4544 17.1432C21.4306 17.1432 22.3363 16.755 23.0068 16.0493C24.0477 14.9613 25.4416 14.3614 26.9412 14.3614V16.2669C25.965 16.2669 25.0593 16.655 24.3888 17.3608C23.3538 18.4488 21.9599 19.0486 20.4603 19.0486Z"
      fill="#001D58"
    />
    <path
      d="M9.56264 17.8614C10.2154 15.0561 11.7681 12.5978 13.997 10.9099C16.2318 12.5919 17.7844 15.0561 18.4314 17.8614H20.3721C19.637 14.1975 17.5668 10.9864 14.5204 8.9515L13.9911 8.59863L13.4618 8.9515C10.4154 10.9864 8.34525 14.1975 7.61011 17.8614H9.56264Z"
      fill="#001D58"
    />
    <path
      d="M8.82757 17.8609C8.75111 17.3198 8.70407 16.7729 8.70407 16.22C8.70407 12.1856 10.6742 8.49812 13.9971 6.23389C17.3258 8.49812 19.2901 12.1856 19.2901 16.22C19.2901 16.7729 19.2371 17.3198 19.1666 17.8609H21.0897C21.1544 17.3198 21.1956 16.7729 21.1956 16.22C21.1956 11.3211 18.6902 6.86317 14.497 4.28724L13.9971 3.9873L13.4972 4.29312C9.30394 6.86317 6.79858 11.3269 6.79858 16.2259C6.79858 16.7787 6.83975 17.3257 6.90444 17.8667H8.82757V17.8609Z"
      fill="#001D58"
    />
  </svg>
);

interface Props {
  headerText: string;
  bodyText: string;
}

const AlertMessage = ({ headerText, bodyText }: Props) => (
  <AlertMessageWrapper>
    <LogoWrapper>
      <LogoIcon />
    </LogoWrapper>
    <AlertHeading>{headerText}</AlertHeading>
    <AlertDescription>{bodyText}</AlertDescription>
  </AlertMessageWrapper>
);

export default AlertMessage;

const AlertMessageWrapper = styled(FlexColAlignCenterBoth)`
  background: #72d4ba;
  border-radius: 10px;
  padding: 36px 50px;
`;

const AlertHeading = styled.h2`
  color: #001d58;
  font-family: 'AvenirNext';
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 12px;
`;

const AlertDescription = styled.p`
  color: #001d58;
  font-family: 'AvenirNext';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;

const LogoWrapper = styled.div`
  height: 28px;
  width: 28px;
  margin-bottom: 18px;
`;
